import { z } from "zod";

export const WithSpanId = <T extends z.ZodRawShape>(
  s: z.ZodObject<T>,
): z.ZodObject<T & { spanId: z.ZodOptional<z.ZodString> }> =>
  s.extend({ spanId: z.string().optional() }) as any; // FIXME Zod types are being weird

export type WithSpanId<T> = T & { spanId?: string };
